'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M54 0v54H0V0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.5 41.75c0 2.612-2.025 4.75-4.5 4.75-2.387 0-4.355-1.988-4.492-4.472l-.008-.278c0-2.612 2.025-4.75 4.5-4.75 2.387 0 4.355 1.988 4.492 4.472l.008.278Zm0-28.5c0 2.613-2.025 4.75-4.5 4.75-2.387 0-4.355-1.988-4.492-4.472l-.008-.278c0-2.612 2.025-4.75 4.5-4.75 2.387 0 4.355 1.988 4.492 4.472l.008.278Zm0 14.25c0 2.613-2.025 4.75-4.5 4.75-2.387 0-4.355-1.988-4.492-4.472L22.5 27.5c0-2.612 2.025-4.75 4.5-4.75 2.387 0 4.355 1.988 4.492 4.472l.008.278Z",
    fill: "#2C2C2E"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.5 27.5c0 1.508-1.12 2.767-2.5 2.767s-2.5-1.259-2.5-2.767 1.12-2.767 2.5-2.767 2.5 1.259 2.5 2.767Zm0 14.233c0 1.508-1.12 2.767-2.5 2.767s-2.5-1.26-2.5-2.767c0-1.509 1.12-2.768 2.5-2.768s2.5 1.26 2.5 2.768Zm0-28.466c0 1.509-1.12 2.768-2.5 2.768s-2.5-1.26-2.5-2.768c0-1.508 1.12-2.767 2.5-2.767s2.5 1.26 2.5 2.767Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
});
var DotsVertical = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.DotsVertical = DotsVertical;